import React, { forwardRef } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import EdgescanMappingForm from './EdgescanMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { Alert } from 'antd';

function EdgescanCredentialsForm(props, ref) {
    const fields = [
    {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
    }, {
        name: "token",
        label: "Token",
        required: true,
        type: FieldTypes.PASSWORD,
    },{
        name: "message",
        type: FieldTypes.LABEL,
        value: <Alert type='warning' message="Assets for this integration will be available after few minutes of adding the credentials, since they are pulled in background."/>
    }];

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={EdgescanMappingForm}
        />
    )
}

export default forwardRef(EdgescanCredentialsForm);